var _path, _path2, _path3, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.19998C4 3.92694 4.50571 2.70604 5.40589 1.80587C6.30606 0.905692 7.52696 0.399979 8.8 0.399979C10.073 0.399979 11.2939 0.905692 12.1941 1.80587C13.0943 2.70604 13.6 3.92694 13.6 5.19998C13.6 6.47302 13.0943 7.69392 12.1941 8.59409C11.2939 9.49427 10.073 9.99998 8.8 9.99998C7.52696 9.99998 6.30606 9.49427 5.40589 8.59409C4.50571 7.69392 4 6.47302 4 5.19998Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 13.6C0.399902 12.2644 1.4835 11.2 2.8107 11.2H10.3083C9.33105 12.3812 8.79747 13.8669 8.7999 15.4C8.7999 16.9636 9.3435 18.4 10.2519 19.5316C9.7779 19.5772 9.2919 19.6 8.7999 19.6C6.5739 19.6 4.5003 19.1368 2.9619 18.1564C1.3995 17.1604 0.399902 15.628 0.399902 13.6Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 15.4C20.8 16.8322 20.2311 18.2057 19.2184 19.2184C18.2057 20.2311 16.8322 20.8 15.4 20.8C13.9678 20.8 12.5943 20.2311 11.5816 19.2184C10.5689 18.2057 10 16.8322 10 15.4C10 13.9678 10.5689 12.5943 11.5816 11.5816C12.5943 10.5689 13.9678 10 15.4 10C16.8322 10 18.2057 10.5689 19.2184 11.5816C20.2311 12.5943 20.8 13.9678 20.8 15.4ZM18.2248 13.1752C18.1691 13.1193 18.1029 13.075 18.03 13.0447C17.9571 13.0145 17.8789 12.9989 17.8 12.9989C17.7211 12.9989 17.6429 13.0145 17.57 13.0447C17.4971 13.075 17.4309 13.1193 17.3752 13.1752L14.2 16.3516L13.4248 15.5752C13.3121 15.4625 13.1593 15.3992 13 15.3992C12.8407 15.3992 12.6879 15.4625 12.5752 15.5752C12.4625 15.6879 12.3992 15.8407 12.3992 16C12.3992 16.1593 12.4625 16.3121 12.5752 16.4248L13.7752 17.6248C13.8309 17.6807 13.8971 17.725 13.97 17.7553C14.0429 17.7855 14.1211 17.8011 14.2 17.8011C14.2789 17.8011 14.3571 17.7855 14.43 17.7553C14.5029 17.725 14.5691 17.6807 14.6248 17.6248L18.2248 14.0248C18.2807 13.9691 18.325 13.9029 18.3553 13.83C18.3855 13.7571 18.4011 13.6789 18.4011 13.6C18.4011 13.5211 18.3855 13.4429 18.3553 13.37C18.325 13.2971 18.2807 13.2309 18.2248 13.1752Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4,
    y1: 0.399979,
    x2: 15.2118,
    y2: 3.77177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D60F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.399902,
    y1: 11.2,
    x2: 11.608,
    y2: 15.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D60F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10,
    y1: 10,
    x2: 22.6132,
    y2: 13.7933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D60F3"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.01667908.svg";
export { ForwardRef as ReactComponent };